var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-group input-group-sm col" },
    [
      _c("div", { staticClass: "input-group-prepend" }, [
        _c("div", { staticClass: "input-group-text" }, [
          _vm._v(" " + _vm._s(_vm.text) + " "),
        ]),
      ]),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selected,
              expression: "selected",
            },
          ],
          staticClass: "custom-select custom-select-sm",
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selected = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              function ($event) {
                return _vm.$emit("change", $event.target.value)
              },
            ],
          },
        },
        _vm._l(_vm.values, function (value, index) {
          return _c("option", { key: index }, [
            _vm._v(" " + _vm._s(value) + " "),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "input-group-append" }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }